import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { T } from "./translations";

const LanguageContext = createContext(null);

const LOCALES = { it: "it-IT", en: "en-IE", de: "de-DE", es: "es-ES" };

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lau_lang") || "it");

  useEffect(() => {
    localStorage.setItem("lau_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => T[lang]?.[key] ?? T.it[key] ?? key, [lang]);

  const fmtPrice = useCallback(
    (value) =>
      new Intl.NumberFormat(LOCALES[lang] || "it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(value || 0),
    [lang]
  );

  const fmtNum = useCallback(
    (value) => new Intl.NumberFormat(LOCALES[lang] || "it-IT").format(value || 0),
    [lang]
  );

  return <LanguageContext.Provider value={{ lang, setLang, t, fmtPrice, fmtNum }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
